module.exports = __webpack_public_path__ + "img/salsa_4895.d5b80e59.jpg";